<!-- <div *ngIf="spinner && withLoader">
  <ngx-spinner color="transparent">
    <img class="main-loader" src="assets/images/animate.gif">
  </ngx-spinner>
</div> -->
<router-outlet></router-outlet>